// extracted by mini-css-extract-plugin
module.exports =  {"leftSection":"leftSection_QV0iVHkh","centerSection":"centerSection_fiIz_09Z","rightSection":"rightSection_vqLnLa3B","flexSingle":"flexSingle_hv9w6xey"};